import { Component, h } from 'preact'
import Panel from '../panel'
import FeaturedTopicsManager from '../featured-topics/FeaturedTopicsManager'
import { FeaturedTopic } from '../featured-topics/FeaturedTopics'
import InputGroup from '../ui-components/InputGroup'

export type featuredTopicsInfoType = {
  featuredTopics: Array<FeaturedTopic>,
  title: string
}

interface Props {
  title: string,
  featuredTopics: Array<FeaturedTopic>,
  onCallback: (featuredTopicInfo: {title: string, featuredTopics: Array<FeaturedTopic>}) => void
}

interface State {
  featuredTopics: Array<FeaturedTopic>,
  title: string
}

export class GroupFeaturedTopics extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      featuredTopics: props.featuredTopics || [],
      title: props.title || ''
    }

    this.setFeaturedTopics = this.setFeaturedTopics.bind(this)
    this.setFeaturedTopicsTitle = this.setFeaturedTopicsTitle.bind(this)
    this.updateCallback = this.updateCallback.bind(this)
  }

  setFeaturedTopics (value: Array<FeaturedTopic>) {
    this.setState({ featuredTopics: value }, () => this.updateCallback())
  }

  setFeaturedTopicsTitle (value: string) {
    this.setState({ title: value }, () => this.updateCallback())
  }

  updateCallback () {
    this.props.onCallback({ title: this.state.title, featuredTopics: this.state.featuredTopics })
  }

  render (_: Props, { title, featuredTopics }: State) {
    return (
      <div>
        <Panel title='Featured topics'>
          <InputGroup
            title='Title'
            placeholder='Add a title'
            type='text'
            onChange={(e: {target: HTMLInputElement}) => { this.setFeaturedTopicsTitle(e.target.value) }}
            value={title} />
          <FeaturedTopicsManager
            searchPlaceholder='Add a topic by pasting topic URL or searching'
            onUpdate={(key, value) => this.setFeaturedTopics(value)}
            featuredTopics={featuredTopics}
          />
        </Panel>
      </div>
    )
  }
}

export default GroupFeaturedTopics
